export class ProgramMealsServed {
    public id: number;
    public snacks: number;
    public breakfast: number;
    public lunch: number;
    public dinner: number;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-meals-served.ts